import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {SearchFilterSetContainerModel} from '../../../../../../models';


@Injectable({providedIn: 'root'})

export class SearchFilterService extends BaseApiTemplateService<SearchFilterSetContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'search-filters/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + 'search-filters/backoffice-ep';
    this.httpClient = http;
  }
}
